// ─── AI Function Registry ────────────────────────────────────────────────────
//
// ⚠️ SUPERSEDED by the backend registry (`packages/backend/src/ai/features.ts`),
// which is what actually resolves a model and bills a call. The settings page
// now renders `GET /ai/features`. This constant is kept only until nothing
// imports it, per the adoption rule that an old thing is not deleted in the
// same change that replaces it.
//
// Every AWS Bedrock–backed feature is registered here with a stable key. The
// key drives two generic behaviours:
//   1. Model selection — each function reads its model id from an App Setting
//      (`settingVarCode`), falling back to the `BEDROCK_MODEL_ID` env default.
//   2. Cost attribution — each Bedrock call is tagged with the function key so
//      spend can be tracked per feature (alongside the app + environment tags).
//
// To make a new AI feature configurable, add an entry here and read its model
// with `getSettingValue(settingVarCode)` on the backend.
export const AI_FUNCTIONS = [
    {
        key: 'grammar',
        settingVarCode: 'ai_model_grammar',
        label: 'Grammar & spelling',
        description: 'Reviews a draft message and suggests a spelling/grammar-corrected version.',
    },
    {
        key: 'translate',
        settingVarCode: 'ai_model_translate',
        label: 'Translation',
        description: 'Translates a draft message into another language, keeping its tone.',
    },
    {
        key: 'document_extraction',
        settingVarCode: 'ai_model_document_extraction',
        label: 'Invoice / quote scan',
        description: 'Extracts amount, vendor, dates and line items from an uploaded invoice or quote.',
    },
    {
        key: 'seating',
        settingVarCode: 'ai_model_seating',
        label: 'AI seating suggestions',
        description: 'Proposes a seating arrangement from guest RSVPs, VIP status and preferences.',
    },
];
/** The App-setting varCode that stores the model id for a given AI function. */
export function aiModelSettingVarCode(key) {
    const def = AI_FUNCTIONS.find((f) => f.key === key);
    return def ? def.settingVarCode : `ai_model_${key}`;
}
/** The model setting that switches an optional AI flow off. */
export const AI_MODEL_OFF = 'off';
/** True when a configured model is the "off" value, however it was typed. */
export function isAiModelOff(model) {
    return typeof model === 'string' && model.trim().toLowerCase() === AI_MODEL_OFF;
}
//# sourceMappingURL=ai.js.map